<div class="container">
    <app-sub-header [inputTransactionData]="transactionData" [currentWorkflowDefault]="currentWorkflowDefault" [currentWorkflowChange]="currentWorkflowChange" [subtitle]="subtitle" [title]="title" [link]="link" (response)="get_response($event)"></app-sub-header>


</div>